module.exports = __webpack_public_path__ + "static/media/Decisions_Step5_Image14.9ae70f7c.jpg";